module.exports = __webpack_public_path__ + "img/ideaPlan.36364cdb.svg";